module.exports = "/_next/static/images/05212ae79593111ab35045598b6ff375-slide-3-small.png.webp";